module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/pc/relation_link_senior_down-ab7bb2045e4b1df05179f74c6abd6899.png";